export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Core Workspace-tilbud med intelligente funksjoner for nåtidens arbeidere som bruker SaaS, webapper og fildelingstjenester.</p><p>Inkluderer SSO med støtte for multifaktorautentisering for alle apper, workspace-intelligens med mikroapper, persontilpasset mating og virtuell hjelp samt Citrix Content Collaboration Standard-tjenesten med ubegrenset lagring av filer.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Komplett løsning for arbeidere som trenger en fullstendig digital arbeidsplass med granulær sikkerhet, men ikke trenger virtuelle apper og stasjonære maskiner.</p><p>Inkluderer Workspace Standard-funksjonalitet, pluss avanserte sikkerhetskontroller for SaaS og web, enhetlig endepunktsadministrasjon og Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Omfattende arbeidsplassløsning med muligheter for hybrid distribusjon av Citrix Virtual Apps and Desktops.</p><p>Inkluderer Workspace Premium-funksjonalitet, pluss et skyadministrasjonsalternativ for Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Med Citrix Workspace Essentials kan små og mellomstore bedrifter beskytte dataene sine ved å forenkle og sikre innloggingsprosessen til SaaS- og nettapplikasjoner.</p><p>Inkluderer enkel pålogging til SaaS- og nettapplikasjoner med multifaktorautentisering for ytterligere sikring av innloggingsprosessen, noe som bidrar til å redusere oddsen for kompromittering av kontoer med 99,9 %.</p>"
            },
            terms: "* Per bruker, per måned",
            btn1: "Se funksjonsmatrise"
        },
        features: {
            disclaimer1: "* USD MSRP månedlig gjennomsnitt per bruker for 500 brukere med et 3-års abonnement. Faktiske priser kan variere.<br /> Lisensalternativene for Citrix Workspace starter på 25 brukere.",
            disclaimer2: "** Workspace Premium-tjenesten inkluderer ikke Workspace Analytics for lokal distribusjon av Citrix Virtual Apps and Desktops."
        },
        calculator: {
            edition: "Velg din versjon",
            title: "Beregn priser",
            users: "Velg brukere",
            estCost: "Dine beregnede månedskostnader",
            btn1: "Snakk med en ekspert",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Lisensalternativene starter på 25 brukere. Prøv på nytt.",
            lowUserMsg: "Har du færre enn 500 brukere? Vi kan hjelpe små og store bedrifter med deres behov.",
            volumeDiscount: "Over 2500 brukere? Få volumrabatt.",
            contract1: "1-års kontrakt",
            contract3: "3-års kontrakt",
            contract3savings: "20 % rabatt",
            term: "* Per bruker, per måned",
            disclaimer: "* Denne kalkulatoren gir estimerte priser og skal kun benyttes for budsjetteringsformål. Faktiske priser kan variere. Ta kontakt med ditt Citrix-team eller -partner for gjeldende rabatter."
        },
        stats: {
            title: "Dine fordeler",
            stat1: {
                title: "Gjør ansattopplevelsen bedre",
                desc: "<b>4 av 5</b> IT-ledere mener at ansattopplevelsen er avgjørende for den digitale transformasjonen."
            },
            stat2: {
                title: "Gi de ansatte valgfrihet",
                desc: "<b>78 %</b> av lederne i næringslivet er enige i at ansattopplevelsen blir bedre hvis de ansatte kan velge hvilke applikasjoner og enheter de vil bruke."
            },
            stat3: {
                title: "Gi enklere tilgang",
                desc: "<b>47 %</b> av lederne i næringslivet sier at den største faktoren for å aktivisere de ansatte er enkel tilgang til informasjonen de trenger for å få jobben gjort."
            },
            btn1: "Snakk med en ekspert",
            disclaimer: "Kilde: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}